import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AuthCallback from "@/components/AuthCallback";
import HomePage from "@/pages/HomePage";
import SearchPage from "@/pages/SearchPage";
import BusinessDetailPage from "@/pages/BusinessDetailPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import BusinessRegisterPage from "@/pages/BusinessRegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import AdminPage from "@/pages/AdminPage";
import FAQPage from "@/pages/FAQPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import CookiesPolicyPage from "@/pages/CookiesPolicyPage";
import InstallAppPage from "@/pages/InstallAppPage";
import InstallPWABanner from "@/components/InstallPWABanner";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";
import { initCookieConsent, setConsentDefaults } from "@/lib/cookieConsent";

// Set Google Consent Mode v2 defaults ASAP (module init, before any effects run).
setConsentDefaults();

function AppRouter() {
  const location = useLocation();

  // Initialize the cookie consent banner once at app load.
  useEffect(() => { initCookieConsent(); }, []);

  // Detect OAuth callback synchronously
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  // /app is a self-contained landing page — no header/footer/nav distractions.
  const isInstallPage = location.pathname === "/app";
  if (isInstallPage) {
    return (
      <>
        <AnalyticsTracker />
        <ScrollToTop />
        <Routes>
          <Route path="/app" element={<InstallAppPage />} />
        </Routes>
      </>
    );
  }

  return (
    <>
      <AnalyticsTracker />
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/business/register" element={<BusinessRegisterPage />} />
        <Route path="/business/:slug" element={<BusinessDetailPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/politique-confidentialite" element={<PrivacyPolicyPage />} />
        <Route path="/conditions-utilisation" element={<TermsPage />} />
        <Route path="/politique-cookies" element={<CookiesPolicyPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      <Footer />
      <InstallPWABanner />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
